const global = {
  namespaced: true,
  state: {
    statuses: [
      {
        value: 1,
        text: 'Active'
      },
      {
        value: 0,
        text: 'InActive'
      }
    ],
    religions: [
      {
        value: 'Islam',
        text: 'Islam'
      },
      {
        value: 'Kristen Protestan',
        text: 'Kristen Protestan'
      },
      {
        value: 'Kristen Katolik',
        text: 'Kristen Katolik'
      },
      {
        value: 'Hindu',
        text: 'Hindu'
      },
      {
        value: 'Buddha',
        text: 'Buddha'
      },
      {
        value: 'Khonghucu',
        text: 'Khonghucu'
      }
    ],
    identity_types: [
      {
        value: 'KTP',
        text: 'KTP'
      },
      {
        value: 'SIM',
        text: 'SIM'
      },
      {
        value: 'PASSPORT',
        text: 'PASSPORT'
      },
      {
        value: 'KTAS',
        text: 'KTAS'
      }
    ],
    genders: [
      {
        value: 'M',
        text: 'Male'
      },
      {
        value: 'F',
        text: 'Female'
      }
    ],
    isHeadOffice: [
      {
        value: 1,
        text: 'Yes'
      },
      {
        value: 0,
        text: 'No'
      }
    ],
    bloods: [
      {
        value: 'O',
        text: 'O'
      },
      {
        value: 'A',
        text: 'A'
      },
      {
        value: 'B',
        text: 'B'
      },
      {
        value: 'AB',
        text: 'AB'
      }
    ],
    MaritialStatus: [
      {
        value: 'single',
        text: 'Single'
      },
      {
        value: 'married',
        text: 'Married'
      },
      {
        value: 'widowed',
        text: 'Widowed'
      },
      {
        value: 'widower',
        text: 'Widower'
      },
      {
        value: 'divorced',
        text: 'Divorced'
      }
    ]
  },
  getters: {
    getCompanies (state) {
      return state.companies
    }
  },
  mutations: {
  },
  actions: {
  }
}

export default global
